import { GapMiniAppSdk } from 'gap-miniapp-sdk';
import { createContext } from 'react';

type TGapSdkContext = {
  gapMiniAppSdk: GapMiniAppSdk | undefined;
  event: {
    onCloseApp: () => void;
  };
};

export const GapSdkContext = createContext<TGapSdkContext>({
  gapMiniAppSdk: undefined,
  event: {
    onCloseApp: () => undefined,
  },
});

export default function GapSdkProvider(props: { children?: React.ReactNode }) {
  const gapMiniAppSdk = new GapMiniAppSdk();

  const onCloseApp = async () => {
    if (gapMiniAppSdk) {
      gapMiniAppSdk.closeApp();
    }
  };

  return (
    <GapSdkContext.Provider
      value={{
        gapMiniAppSdk: gapMiniAppSdk,
        event: {
          onCloseApp: () => onCloseApp(),
        },
      }}
    >
      {props.children}
    </GapSdkContext.Provider>
  );
}
